// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");

function scaleStringFromNps(scale, includeZero) {
  if (scale === "FiveScale") {
    if (includeZero) {
      return "0_5";
    } else {
      return "1_5";
    }
  } else if (includeZero) {
    return "0_10";
  } else {
    return "1_10";
  }
}

function stepCount(scaleString) {
  switch (scaleString) {
    case "0_10" :
        return 11;
    case "0_5" :
        return 6;
    case "1_10" :
        return 10;
    default:
      return 5;
  }
}

function startValue(scaleString) {
  if (scaleString === "0_10" || scaleString === "0_5") {
    return 0;
  } else {
    return 1;
  }
}

function endValue(scaleString) {
  switch (scaleString) {
    case "0_10" :
    case "1_10" :
        return 10;
    default:
      return 5;
  }
}

function defaultItemsForScaleAndType(scaleString, visualType) {
  var start = startValue(scaleString);
  var end = endValue(scaleString);
  var values = Belt_Array.makeBy((end - start | 0) + 1 | 0, (function (i) {
          return start + i | 0;
        }));
  var colorFor = function (v) {
    switch (scaleString) {
      case "0_10" :
      case "1_10" :
          break;
      default:
        if (v <= 2) {
          return "#E60000";
        } else if (v <= 3) {
          return "#F79406";
        } else {
          return "#21AD04";
        }
    }
    if (v <= 6) {
      return "#E60000";
    } else if (v <= 8) {
      return "#F79406";
    } else {
      return "#21AD04";
    }
  };
  var emojiFor = function (v) {
    switch (scaleString) {
      case "0_10" :
      case "1_10" :
          break;
      default:
        if (v <= 2) {
          return "😞";
        } else if (v <= 3) {
          return "😐";
        } else {
          return "😊";
        }
    }
    if (v <= 3) {
      return "😞";
    } else if (v <= 6) {
      return "😐";
    } else {
      return "😊";
    }
  };
  return Belt_Array.map(values, (function (v) {
                switch (visualType) {
                  case "emoji" :
                      return {
                              value: v,
                              content: emojiFor(v),
                              url: "",
                              inline: "",
                              color: ""
                            };
                  case "star" :
                      return {
                              value: v,
                              content: String(v),
                              url: "",
                              inline: "",
                              color: ""
                            };
                  case "svg" :
                      return {
                              value: v,
                              content: "",
                              url: "",
                              inline: "",
                              color: ""
                            };
                  default:
                    return {
                            value: v,
                            content: String(v),
                            url: "",
                            inline: "",
                            color: colorFor(v)
                          };
                }
              }));
}

function encodeCustomItem(it) {
  return Json_encode.object_({
              hd: [
                "value",
                it.value
              ],
              tl: {
                hd: [
                  "content",
                  it.content
                ],
                tl: {
                  hd: [
                    "url",
                    it.url
                  ],
                  tl: {
                    hd: [
                      "inline",
                      it.inline
                    ],
                    tl: {
                      hd: [
                        "color",
                        it.color
                      ],
                      tl: /* [] */0
                    }
                  }
                }
              }
            });
}

function buildCustomConfig(visualType, customItems) {
  var dict = {};
  dict["visualType"] = visualType;
  if (visualType !== "number" && customItems.length !== 0) {
    var itemsJson = Json_encode.array(encodeCustomItem, customItems);
    dict["items"] = itemsJson;
  }
  return dict;
}

function defaultCategoryRanges(scaleString) {
  switch (scaleString) {
    case "0_5" :
        return {
                detractor: {
                  min: 0,
                  max: 2
                },
                passive: {
                  min: 3,
                  max: 3
                },
                promoter: {
                  min: 4,
                  max: 5
                }
              };
    case "1_10" :
        return {
                detractor: {
                  min: 1,
                  max: 6
                },
                passive: {
                  min: 7,
                  max: 8
                },
                promoter: {
                  min: 9,
                  max: 10
                }
              };
    case "1_5" :
        return {
                detractor: {
                  min: 1,
                  max: 3
                },
                passive: {
                  min: 4,
                  max: 4
                },
                promoter: {
                  min: 5,
                  max: 5
                }
              };
    default:
      return {
              detractor: {
                min: 0,
                max: 6
              },
              passive: {
                min: 7,
                max: 8
              },
              promoter: {
                min: 9,
                max: 10
              }
            };
  }
}

function defaultCategoryColors(param) {
  return {
          detractor: "#E60000",
          passive: "#F79406",
          promoter: "#21AD04"
        };
}

function encodeCategoryRanges(r) {
  return Json_encode.object_({
              hd: [
                "detractor",
                Json_encode.object_({
                      hd: [
                        "min",
                        r.detractor.min
                      ],
                      tl: {
                        hd: [
                          "max",
                          r.detractor.max
                        ],
                        tl: /* [] */0
                      }
                    })
              ],
              tl: {
                hd: [
                  "passive",
                  Json_encode.object_({
                        hd: [
                          "min",
                          r.passive.min
                        ],
                        tl: {
                          hd: [
                            "max",
                            r.passive.max
                          ],
                          tl: /* [] */0
                        }
                      })
                ],
                tl: {
                  hd: [
                    "promoter",
                    Json_encode.object_({
                          hd: [
                            "min",
                            r.promoter.min
                          ],
                          tl: {
                            hd: [
                              "max",
                              r.promoter.max
                            ],
                            tl: /* [] */0
                          }
                        })
                  ],
                  tl: /* [] */0
                }
              }
            });
}

function encodeCategoryColors(c) {
  return Json_encode.object_({
              hd: [
                "detractor",
                c.detractor
              ],
              tl: {
                hd: [
                  "passive",
                  c.passive
                ],
                tl: {
                  hd: [
                    "promoter",
                    c.promoter
                  ],
                  tl: /* [] */0
                }
              }
            });
}

function getCategoryRangesFromConfig(config, scaleString) {
  if (config === undefined) {
    return defaultCategoryRanges(scaleString);
  }
  var d = Js_json.decodeObject(config);
  if (d === undefined) {
    return defaultCategoryRanges(scaleString);
  }
  var cr = Js_dict.get(d, "categoryRanges");
  if (cr === undefined) {
    return defaultCategoryRanges(scaleString);
  }
  var crd = Js_json.decodeObject(cr);
  if (crd === undefined) {
    return defaultCategoryRanges(scaleString);
  }
  var getRange = function (key) {
    var o = Js_dict.get(crd, key);
    if (o === undefined) {
      return ;
    }
    var obj = Js_json.decodeObject(o);
    if (obj === undefined) {
      return ;
    }
    var __x = Js_dict.get(obj, "min");
    var __x$1 = Belt_Option.flatMap(__x, Js_json.decodeNumber);
    var min = Belt_Option.map(__x$1, (function (prim) {
            return prim | 0;
          }));
    var __x$2 = Js_dict.get(obj, "max");
    var __x$3 = Belt_Option.flatMap(__x$2, Js_json.decodeNumber);
    var max = Belt_Option.map(__x$3, (function (prim) {
            return prim | 0;
          }));
    if (min !== undefined && max !== undefined) {
      return {
              min: min,
              max: max
            };
    }
    
  };
  var __x = getRange("detractor");
  var detractor = Belt_Option.getWithDefault(__x, defaultCategoryRanges(scaleString).detractor);
  var __x$1 = getRange("passive");
  var passive = Belt_Option.getWithDefault(__x$1, defaultCategoryRanges(scaleString).passive);
  var __x$2 = getRange("promoter");
  var promoter = Belt_Option.getWithDefault(__x$2, defaultCategoryRanges(scaleString).promoter);
  return {
          detractor: detractor,
          passive: passive,
          promoter: promoter
        };
}

function getCategoryColorsFromConfig(config) {
  var defaults = {
    detractor: "#E60000",
    passive: "#F79406",
    promoter: "#21AD04"
  };
  if (config === undefined) {
    return defaults;
  }
  var d = Js_json.decodeObject(config);
  if (d === undefined) {
    return defaults;
  }
  var cc = Js_dict.get(d, "categoryColors");
  if (cc === undefined) {
    return defaults;
  }
  var ccd = Js_json.decodeObject(cc);
  if (ccd === undefined) {
    return defaults;
  }
  var getStr = function (key, fallback) {
    var __x = Js_dict.get(ccd, key);
    return Belt_Option.getWithDefault(Belt_Option.flatMap(__x, Js_json.decodeString), fallback);
  };
  return {
          detractor: getStr("detractor", "#E60000"),
          passive: getStr("passive", "#F79406"),
          promoter: getStr("promoter", "#21AD04")
        };
}

function categoryForValue(ranges, value) {
  if (value >= ranges.detractor.min && value <= ranges.detractor.max) {
    return "detractor";
  } else if (value >= ranges.passive.min && value <= ranges.passive.max) {
    return "passive";
  } else if (value >= ranges.promoter.min && value <= ranges.promoter.max) {
    return "promoter";
  } else {
    return ;
  }
}

function defaultColorForStep(scaleString, value) {
  switch (scaleString) {
    case "0_10" :
    case "1_10" :
        break;
    default:
      if (value <= 2) {
        return "#E60000";
      } else if (value <= 3) {
        return "#F79406";
      } else {
        return "#21AD04";
      }
  }
  if (value <= 6) {
    return "#E60000";
  } else if (value <= 8) {
    return "#F79406";
  } else {
    return "#21AD04";
  }
}

function colorForStepValue(scaleString, value, ranges, colors) {
  var match = categoryForValue(ranges, value);
  if (match === undefined) {
    return defaultColorForStep(scaleString, value);
  }
  switch (match) {
    case "detractor" :
        return colors.detractor;
    case "passive" :
        return colors.passive;
    case "promoter" :
        return colors.promoter;
    default:
      return defaultColorForStep(scaleString, value);
  }
}

function validateCategoryRanges(scaleString, r) {
  var start = startValue(scaleString);
  var end_ = endValue(scaleString);
  var minOk = r.detractor.min >= start && r.passive.min >= start && r.promoter.min >= start;
  var maxOk = r.detractor.max <= end_ && r.passive.max <= end_ && r.promoter.max <= end_;
  if (!minOk || !maxOk) {
    return "Min and max must be within scale " + String(start) + "-" + String(end_);
  }
  var overlaps = function (a, b) {
    if (a.min <= b.max) {
      return b.min <= a.max;
    } else {
      return false;
    }
  };
  if (overlaps(r.detractor, r.passive) || overlaps(r.detractor, r.promoter) || overlaps(r.passive, r.promoter)) {
    return "Ranges must not overlap";
  }
  var covered = Belt_Array.makeBy((end_ - start | 0) + 1 | 0, (function (i) {
          return start + i | 0;
        }));
  var inRange = function (v, x) {
    if (v >= x.min) {
      return v <= x.max;
    } else {
      return false;
    }
  };
  var allCovered = Belt_Array.every(covered, (function (v) {
          if (inRange(v, r.detractor) || inRange(v, r.passive)) {
            return true;
          } else {
            return inRange(v, r.promoter);
          }
        }));
  if (!allCovered) {
    return "Ranges must cover all values from " + String(start) + " to " + String(end_);
  }
  
}

function mergeCategoryIntoConfig(baseConfig, categoryRanges, categoryColors) {
  var dict = {};
  if (baseConfig !== undefined) {
    var d = Js_json.decodeObject(baseConfig);
    if (d !== undefined) {
      Belt_Array.forEach(Js_dict.entries(d), (function (param) {
              dict[param[0]] = param[1];
            }));
    }
    
  }
  dict["categoryRanges"] = encodeCategoryRanges(categoryRanges);
  dict["categoryColors"] = encodeCategoryColors(categoryColors);
  return dict;
}

var visualTypeOptions = {
  hd: [
    "rounded_box_with_smiley",
    "Rounded Box With Smiley"
  ],
  tl: {
    hd: [
      "rounded_box",
      "Rounded Box"
    ],
    tl: {
      hd: [
        "square_box",
        "Square Box"
      ],
      tl: {
        hd: [
          "gradient_scale_with_smiley",
          "Gradient Scale With Smiley"
        ],
        tl: {
          hd: [
            "custom",
            "Custom (star, emoji, SVG...)"
          ],
          tl: /* [] */0
        }
      }
    }
  }
};

var customVisualTypeOptions = {
  hd: [
    "star",
    "Star"
  ],
  tl: {
    hd: [
      "emoji",
      "Emoji"
    ],
    tl: {
      hd: [
        "svg",
        "SVG"
      ],
      tl: {
        hd: [
          "number",
          "Number"
        ],
        tl: /* [] */0
      }
    }
  }
};

var colorOptions = {
  hd: [
    "#E60000",
    "Red"
  ],
  tl: {
    hd: [
      "#F79406",
      "Yellow"
    ],
    tl: {
      hd: [
        "#21AD04",
        "Green"
      ],
      tl: /* [] */0
    }
  }
};

exports.visualTypeOptions = visualTypeOptions;
exports.customVisualTypeOptions = customVisualTypeOptions;
exports.colorOptions = colorOptions;
exports.scaleStringFromNps = scaleStringFromNps;
exports.stepCount = stepCount;
exports.startValue = startValue;
exports.endValue = endValue;
exports.defaultItemsForScaleAndType = defaultItemsForScaleAndType;
exports.encodeCustomItem = encodeCustomItem;
exports.buildCustomConfig = buildCustomConfig;
exports.defaultCategoryRanges = defaultCategoryRanges;
exports.defaultCategoryColors = defaultCategoryColors;
exports.encodeCategoryRanges = encodeCategoryRanges;
exports.encodeCategoryColors = encodeCategoryColors;
exports.getCategoryRangesFromConfig = getCategoryRangesFromConfig;
exports.getCategoryColorsFromConfig = getCategoryColorsFromConfig;
exports.categoryForValue = categoryForValue;
exports.defaultColorForStep = defaultColorForStep;
exports.colorForStepValue = colorForStepValue;
exports.validateCategoryRanges = validateCategoryRanges;
exports.mergeCategoryIntoConfig = mergeCategoryIntoConfig;
/* No side effect */
